import AuthService from "../../AuthService";
const travelInfo = {
  getTravelInfo(page) {
    return AuthService.get(`service/travel_info?page=${page}`);
  },
  showTravelInfo(id) {
    return AuthService.get("/service/travel_info/" + id);
  },
  createTravelInfo(data) {
    return AuthService.post("/service/travel_info", data);
  },
  updateTravelInfo(id, data) {
    return AuthService.put("/service/travel_info/" + id, data);
  },
  deleteTravelInfo(id) {
    return AuthService.delete("/service/travel_info/" + id);
  }
};
export default travelInfo;
